import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import range from 'lodash/range';
import generalStyles from './style/general.module.css';

const cx = classNames.bind({ ...generalStyles });

const bgValues = [
  'green',
  'licorice',
  'marvel',
  'orange',
  'pink',
  'purple',
  'red',
  'black',
  'snow--d',
  'teal',
  'white',
  'yellow',
];

export default function OffsetBackground({
  children,
  backgroundColor,
  height,
}) {
  const bgClassName = cx('bg', `bg-${backgroundColor}`, `height-${height}`);

  return (
    <div className={cx('offsetBackground')}>
      <div className={bgClassName} />
      <div className={cx('content')}>{children}</div>
    </div>
  );
}

OffsetBackground.propTypes = {
  children: PropTypes.node.isRequired,
  backgroundColor: PropTypes.oneOf(bgValues),
  height: PropTypes.oneOf(range(5, 105, 5)),
};

OffsetBackground.defaultProps = {
  backgroundColor: 'marvel',
  height: 50,
};



// WEBPACK FOOTER //
// ./src/components/wrappers/OffsetBackground/index.js